import PropTypes from 'prop-types';
import React from 'react';

import CustomFieldValueFields from './CustomFieldValueFields';

const TicketAnswerBlocks = ({ blocks = [], ...fieldProps }) => (
  blocks.map((block) => (
    <div key={block.key} className="ticket-answer-block" data-testid={`ticket-answers-${block.key}`}>
      <div className="row">
        <div className="col-12">
          <p className="ticket-answer-block-title" style={{ fontSize: '16px', fontWeight: 600, margin: '20px 0 0 0' }}>
            {block.label}
          </p>
        </div>
      </div>
      <CustomFieldValueFields {...fieldProps} customFieldValues={block.answers} idSuffix={`ticket-${block.key}`} />
    </div>
  ))
);

TicketAnswerBlocks.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    answers: PropTypes.array.isRequired,
  })),
};

export default TicketAnswerBlocks;
